var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:{ 'icon-thumbnail': _vm.icon },attrs:{"src":_vm.imgData,"alt":"thumbnail"}})}
var staticRenderFns = []

export { render, staticRenderFns }